import dynamic from 'next/dynamic'
import { LocationVisitsIcon } from 'src/components/insights/icons/location-visits'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/hour-of-day.png'

const HourOfDayVisits = dynamic(() => import('src/components/insights/location-visits/hour-of-day'), { ssr: false })

export const HourOfDayWidget: InsightBuilderWidget = {
  id: 'hour-of-day',
  name: 'Hour of Day (Visits Distribution)',
  type: 'Location Visits',
  icon: LocationVisitsIcon,
  component: HourOfDayVisits,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
